module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kyRB3"))).then(() => parcelRequire('d4rZH'));